export const validations = {
    'VISA': {
        'regex': '^4[0-9]{12}([0-9]{3}|[0-9]{6})?$',
        'comment': 'All Visa card numbers start with a 4. Cards have 13, 16, or 19 digits. ',
        'maxLength': 19
    },
    'MC': {
        'regex': '^(5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$',
        'comment': 'MasterCard numbers either start with the numbers 51 through 55 or with the numbers 2221 through 2720. All have 16 digits.',
        'maxLength': 16
    },
    'DISC': {
        'regex': '^6(011|[4-5][0-9]{2})[0-9]{12,15}$',
        'comment': 'Discover card numbers begin with 6011, 64, or 65. Cards have 16-19 digits.',
        'maxLength': 19
    },
    'AMEX': {
        'regex': '^3[47][0-9]{13}$',
        'comment': 'American Express card numbers start with 34 or 37 and have 15 digits.',
        'maxLength': 15
    },
    "DINE": {
        'regex': '^3([68][0-9]|0[0-5])[0-9]{11}',
        'maxLength': 14
    },
    'JCB': {
        'regex': '^35[0-9]{13}',
        'maxLength': 16
    },
    'WIRE': {
        'regex': '',
        'comment': 'Wire has no regex validation.'
    },
    'CEDN': {
        'regex': '^97880[\\d]{10}$',
        'comment': 'Cedyna numbers start with 97880 followed by 10 digits.',
        'maxLength': 15
    },
    'SDD': {
        'regex': '^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$',
        'Comment': 'SEPA IBAN comprises a two-letter country code, a two-digit check value, and a basic bank account number (BBAN) comprising up to 30 alphanumeric characters. BBAN length and format vary by country.',
        'maxLength': 34
    }
};
